import React, {useState, useEffect, useRef} from 'react';
import Pagination from 'react-js-pagination';
import {useSelector} from 'react-redux';
import {NavLink, useHistory, useLocation} from 'react-router-dom';
import Table from 'react-bootstrap/Table';
import {toast} from 'react-toastify';
import {useMutation, useQueryClient, useQuery} from 'react-query';
import {Image} from 'react-bootstrap';
import {AsyncPaginate} from 'react-select-async-paginate';
import {
    EXERCISE_API,
    BaseGatewayImage,
    DISEASE_API,
    ACCOUNT_API,
    PATIENTEXERCISE_API,
    PATIENTEXERCISEPRACTICE_API
} from '@app/utils/apiUrl.js';
import {DeleteSingle, Get, Post, Put} from '@app/utils/httpProvider';
import {
    createUrlWithParam,
    dateTimeToString,
    dateTimeToStringRequest,
    formatDateTimeCrawler,
    formatDateTimeMoment,
    formatDateTimeWithoutHour,
    formatDateTimeWithoutHourMoment,
    getInfomationAccountFromToken,
    isValidUrl
} from '../../utils/helper';
import {URI_INTERNAL} from '../../utils/pathLocations';
import {
    objectShowNumber,
    messageToast,
    objectDeviceStatus,
    deviceStatus,
    styleSelectDefault,
    role,
    objectTrangThaiDeNghi,
    trangThaiDeNghiValue,
    sortByValue,
    objectPracticeStatus,
    practiceStatus,
    status200,
    status201,
    messageError,
    objectDoctorEvaluationStatus,
    styleSelectError,
    doctorEvaluationStatus
} from '../../utils/define';
import {ConfirmModal} from '../../modules/modal/ConfirmModal';
import {BrowserView, MobileView} from 'react-device-detect';
import Select from 'react-select';
import {Button} from '@components';
import {Card, Form, Row, Col, ButtonGroup} from 'react-bootstrap';
import ReactPlayer from 'react-player';
import {isMobile} from 'react-device-detect';
import {Formik} from 'formik';
import * as yup from 'yup';
import VideoInput from '@app/components/video-input/VideoInput';

const schema = yup.object().shape({
    feedbackDoctor: yup.string().required('Trường dữ liệu không được để trống'),
    doctorEvaluationStatus: yup
        .object()
        .nullable()
        .required('Trường dữ liệu không được để trống')
});

const DoctorObserveDetail = () => {
    const history = useHistory();
    const location = useLocation();
    const valueSearch = useSelector((state) => state.search.valueSearch);

    const queryClient = useQueryClient();

    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(20);
    const [search, setSearch] = useState('');

    const [openConfirmDeleteModal, setOpenConfirmDeleteModal] = useState(false);
    const [idWantDelete, setIdWantDelete] = useState('');
    const [confirmDelMessage, setConfirmDelMessage] = useState('');
    const [isAddedPratice, setIsAddedPratice] = useState(false);

    const videoRef = useRef();
    const descRef = useRef();

    let accountRoleAdmin = false;
    const inforAccount = getInfomationAccountFromToken();

    if (inforAccount && inforAccount.role) {
        const userRole = inforAccount.role.split(', ');
        accountRoleAdmin = userRole.includes(role.Admin);
    }

    const deleteFunc = useMutation((value) =>
        DeleteSingle(EXERCISE_API.DELETE_ITEM, value, null)
    );

    const paramUrl = new URLSearchParams(location.search.substring(1));
    if (
        paramUrl.get('page') != null &&
        parseInt(paramUrl.get('page'), 10) !== page
    ) {
        const pageResult = parseInt(paramUrl.get('page'), 10);
        setPage(pageResult);
    }
    if (
        paramUrl.get('size') != null &&
        parseInt(paramUrl.get('size'), 10) !== pageSize
    ) {
        const sizeResult = parseInt(paramUrl.get('size'), 10);
        setPageSize(sizeResult);
    }
    if (paramUrl.get('search') != null && paramUrl.get('search') !== search) {
        setSearch(paramUrl.get('search'));
    }

    // const [exerciseId, setExerciseId] = useState(
    //     paramUrl.get('baitapId') ? paramUrl.get('baitapId') : ''
    // );
    // const [accountDoctorId, setAccountDoctorId] = useState(
    //     paramUrl.get('bacsiId') ? paramUrl.get('bacsiId') : ''
    // );

    const [patientExerciseId, setPatientExerciseId] = useState(
        paramUrl.get('id') ? paramUrl.get('id') : ''
    );

    // const [isSortedNameAlphabet, setIsSortedNameAlphabet] = useState(false);

    // const {isLoading, isError, error, data, refetch} = useQuery(
    //     ['exerciseData', valueSearch, page, pageSize],
    //     () => {
    //         let model = {
    //             Keyword: valueSearch ? valueSearch : '',
    //             PageIndex: page,
    //             PageSize: pageSize,
    //             DiseaseId:
    //                 diseaseId && diseaseId.target && diseaseId.target.value
    //                     ? diseaseId.target.value.value
    //                     : ''
    //         };

    //         return Get(EXERCISE_API.GET_PAGING, null, model);
    //     }
    // );

    // const exerciseItem = useQuery(
    //     ['exercisePatientData'],
    //     () => Get(EXERCISE_API.GET_ITEM, exerciseId),
    //     {enabled: !!exerciseId}
    // );

    // const accountDoctorItem = useQuery(
    //     ['doctorPatientData'],
    //     () => Get(ACCOUNT_API.GET_BY_ID_ACCOUNT, accountDoctorId),
    //     {enabled: !!accountDoctorId}
    // );

    // const lstPatientExerciseItem = useQuery(
    //     ['patientExerciseData'],
    //     () => {
    //         var model = {
    //             AccountPatientId: inforAccount.id,
    //             AccountDoctorId: accountDoctorId,
    //             ExerciseId: exerciseId
    //         };
    //         return Get(PATIENTEXERCISE_API.GET_PAGING, null, model);
    //     },
    //     {
    //         // don’t even start this query until we have the patient’s account
    //         enabled: !!inforAccount.id
    //     }
    // );

    const patientExerciseItem = useQuery(
        ['doctorObserveDetailData'],
        () => Get(PATIENTEXERCISE_API.GET_ITEM, patientExerciseId),
        {enabled: !!patientExerciseId}
    );

    const isLoading = patientExerciseItem.isLoading ? true : false;
    const isError = patientExerciseItem.isError ? true : false;
    const error = patientExerciseItem.isError
        ? patientExerciseItem.error
        : null;

    // useEffect(() => {
    //     if (!videoRef.current || !descRef.current) return;
    //     if (videoRef.current.offsetHeight === 0) return;

    //     // bottom of the videoLink relative to the description container
    //     const bottomOfVideo =
    //         videoRef.current.offsetTop + videoRef.current.offsetHeight;

    //     descRef.current.querySelectorAll('figure').forEach((fig) => {
    //         // if the figure’s top is below the video’s bottom → center it
    //         if (fig.offsetTop > bottomOfVideo + 30) {
    //             fig.classList.add('centered');
    //         } else {
    //             fig.classList.remove('centered');
    //         }
    //     });
    // }, [exerciseItem.data]);

    // useEffect(() => {
    //     refetch();
    // }, [pageSize, page]);

    const replaceHistory = async (Page, Size, Search) => {
        history.replace(
            createUrlWithParam(URI_INTERNAL.EXERCISE_PATH, {
                page: Page,
                size: Size,
                search: Search
            })
        );
    };

    React.useEffect(() => {
        if (valueSearch != null && valueSearch !== search) {
            replaceHistory(1, pageSize, valueSearch);
        }
    }, [valueSearch]);

    const changePage = (number) => {
        setPage(number);
        replaceHistory(number, pageSize, search);
    };

    const onChangeShowNumber = (e) => {
        setPageSize(e.target.value);
        replaceHistory(page, e.target.value, search);
    };

    // useEffect(() => {
    //     if (isAddedPratice) {
    //         lstPatientExerciseItem.refetch();

    //         setIsAddedPratice(false);
    //     }
    // }, [isAddedPratice]);

    // useEffect(() => {
    //     if (!accountDoctorId && !exerciseId) {
    //         if (
    //             lstPatientExerciseItem &&
    //             lstPatientExerciseItem.data &&
    //             lstPatientExerciseItem.data.data &&
    //             lstPatientExerciseItem.data.data.length > 0
    //         ) {
    //             const first = lstPatientExerciseItem.data.data[0];
    //             setExerciseId(first.exerciseId);
    //             setAccountDoctorId(first.accountDoctorId);

    //             // exerciseItem.refetch();
    //             // accountDoctorItem.refetch();
    //         }
    //     }
    // }, [lstPatientExerciseItem.data]);

    // useEffect(() => {
    //     exerciseItem.refetch();
    // }, [exerciseId]);

    // useEffect(() => {
    //     accountDoctorItem.refetch();
    // }, [accountDoctorId]);

    // const deleteAction = (id, name) => {
    //     setIdWantDelete(id);
    //     setConfirmDelMessage(name);
    //     setOpenConfirmDeleteModal(true);
    // };

    // const acceptDelete = async () => {
    //     if (idWantDelete !== '') {
    //         deleteFunc.mutate(idWantDelete, {
    //             onSuccess: (res) => {
    //                 if (res.status === 201 || res.status === 200) {
    //                     refetch();
    //                     toast.success(messageToast.messageToastDeleteSuccess);
    //                     if (
    //                         data != null &&
    //                         data.data.length === 1 &&
    //                         page !== 1
    //                     ) {
    //                         history.push(
    //                             createUrlWithParam(URI_INTERNAL.EXERCISE_PATH, {
    //                                 page: page - 1,
    //                                 size: pageSize,
    //                                 search: search
    //                             })
    //                         );
    //                     }
    //                 } else {
    //                     toast.error(messageToast.messageToastDeleteError);
    //                 }
    //             },
    //             onError: (res) => {
    //                 toast.error(messageToast.messageToastTryCatch);
    //             }
    //         });

    //         replaceHistory(page, pageSize, search);
    //         setOpenConfirmDeleteModal(false);
    //     }
    // };

    // const cancelDelete = () => {
    //     setIdWantDelete('');
    //     setOpenConfirmDeleteModal(false);
    // };

    let videoLink = '';
    if (
        patientExerciseItem &&
        patientExerciseItem.data &&
        patientExerciseItem.data.exercise
    ) {
        if (isValidUrl(patientExerciseItem.data.exercise.videoLink)) {
            if (
                patientExerciseItem.data.exercise.videoLink.includes(
                    'www.youtube.com'
                )
            ) {
                videoLink = patientExerciseItem.data.exercise.videoLink.replace(
                    'watch?v=',
                    'embed/'
                );
            }
            videoLink = patientExerciseItem.data.exercise.videoLink;
        } else {
            videoLink =
                BaseGatewayImage + patientExerciseItem.data.exercise.videoLink;
        }
    }

    const doMeasure = () => {
        const vidEl = videoRef.current;
        const descEl = descRef.current;
        if (!vidEl || !descEl) return;

        // now offsetHeight will be correct
        const bottom = vidEl.offsetTop + vidEl.offsetHeight;

        descEl.querySelectorAll('figure').forEach((fig) => {
            if (fig.offsetTop > bottom) fig.classList.add('centered');
            else fig.classList.remove('centered');
        });
    };

    const addFunc = useMutation((value) =>
        Post(PATIENTEXERCISE_API.ADD_ITEM, null, value, false, true)
    );

    const addPracticeFunc = useMutation((value) =>
        Post(PATIENTEXERCISEPRACTICE_API.ADD_ITEM, null, value, false)
    );

    const updatePracticeFunc = useMutation((value) =>
        Put(PATIENTEXERCISE_API.UPDATE_ITEM, patientExerciseId, value)
    );

    const [visibleVideos, setVisibleVideos] = useState({});

    const toggleVideo = (practiceId) => {
        setVisibleVideos((prev) => ({
            ...prev,
            [practiceId]: !prev[practiceId]
        }));
    };

    const handleUpdate = async (values) => {
        var model = {...patientExerciseItem?.data};
        model.feedbackDoctor = values.feedbackDoctor;
        model.doctorEvaluationStatus = values.doctorEvaluationStatus.value;
        if (
            patientExerciseItem?.data.patientExerciseStatus ==
            practiceStatus.Pending
        ) {
            if (values && values.agreeWithPatient) {
                model.patientExerciseStatus = practiceStatus.Reviewed;
            } else {
                model.patientExerciseStatus = practiceStatus.Rejected;
            }
        }
        if (
            model &&
            patientExerciseItem?.data.patientExerciseStatus ==
                practiceStatus.Pending
        ) {
            await updatePracticeFunc.mutateAsync(model, {
                onSuccess: (res) => {
                    if (res.status !== status200) {
                        toast.error(messageToast.messageToastUpdateError);
                    } else {
                        toast.success(messageToast.messageToastUpdateSuccess);
                        // queryClient.setQueryData(diseaseId, model);
                        queryClient.invalidateQueries([patientExerciseId]);
                        history.goBack();
                    }
                },
                onError: (res) => {
                    toast.error(
                        res.message || 'Đã có lỗi xảy ra, vui lòng thử lại !'
                    );
                }
            });
        } else {
            toast.error('Đã phản hồi');
        }
    };

    const handleUpdateThongSo = async (values) => {
        var model = {...values};
        model.exerciseId = values.exercises.value;

        model.accountDoctorId = patientExerciseItem?.data.accountDoctorId;
        model.accountPatientId = patientExerciseItem?.data.accountPatientId;
        model.patientExerciseStatus =
            patientExerciseItem?.data.patientExerciseStatus;
        model.id = patientExerciseItem?.data.id;

        if (
            model &&
            patientExerciseItem?.data.patientExerciseStatus ==
                practiceStatus.InProgress
        ) {
            await updatePracticeFunc.mutateAsync(model, {
                onSuccess: (res) => {
                    if (res.status !== status200) {
                        toast.error(messageToast.messageToastUpdateError);
                    } else {
                        toast.success(messageToast.messageToastUpdateSuccess);
                        // queryClient.setQueryData(diseaseId, model);
                        queryClient.invalidateQueries([patientExerciseId]);
                        history.goBack();
                    }
                },
                onError: (res) => {
                    toast.error(
                        res.message || 'Đã có lỗi xảy ra, vui lòng thử lại !'
                    );
                }
            });
        } else {
            toast.error('Đã phản hồi');
        }
    };

    const loadExerciseOptions = async (
        search,
        loadedOptions,
        {page, lstDiseaseId}
    ) => {
        const pageSize = 10;
        const res = await Get(EXERCISE_API.GET_PAGING, null, {
            PageIndex: page,
            PageSize: pageSize,
            LstDiseaseId: lstDiseaseId.map((x) => x.value),
            Keyword: search // pass the input text to filter server-side
        });

        const data = res.data || [];
        const options = data.map((x) => ({
            label: `${x.name}`,
            value: x.id
        }));

        // assume your API returns total count or a flag for more pages
        const hasMore = data.length === pageSize;
        return {
            options,
            hasMore,
            additional: {page: page + 1}
        };
    };

    return (
        <div className="container-fluid">
            {isLoading || isError ? (
                <h3 className="card-title">Chưa load được chi tiết</h3>
            ) : (
                <>
                    <div id="practice-tab-content" className="tab-content">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="card card-primary card-outline">
                                    <div className="card-header">
                                        <h4>
                                            <i className="fas fa-dumbbell text-primary" />{' '}
                                            {patientExerciseItem &&
                                            patientExerciseItem.data &&
                                            patientExerciseItem.data.exercise
                                                ? patientExerciseItem.data
                                                      .exercise.name
                                                : ''}
                                        </h4>
                                    </div>
                                    <div
                                        className="card-body"
                                        id="exercise-details"
                                    >
                                        {!isMobile ? (
                                            <div className="row">
                                                <div className="col-12">
                                                    {videoLink && (
                                                        <div
                                                            ref={videoRef}
                                                            className="float-md-end w-100 w-md-50 ms-md-3 mb-3"
                                                            style={{
                                                                maxWidth: '45%'
                                                            }}
                                                        >
                                                            <ReactPlayer
                                                                url={videoLink}
                                                                width="100%"
                                                                height="auto"
                                                                onReady={
                                                                    doMeasure
                                                                }
                                                                controls
                                                                muted
                                                                loop
                                                                playing
                                                                playsinline
                                                            />
                                                        </div>
                                                    )}

                                                    <div
                                                        ref={descRef}
                                                        className="html-dangerouslySetInner"
                                                        dangerouslySetInnerHTML={{
                                                            __html:
                                                                patientExerciseItem
                                                                    ?.data
                                                                    ?.exercise
                                                                    ?.description ||
                                                                ''
                                                        }}
                                                    />

                                                    <p>
                                                        <i className="fas fa-user-md text-info" />{' '}
                                                        Được điều trị bởi:{' '}
                                                        {console.log(
                                                            'patientExerciseItem',
                                                            patientExerciseItem
                                                        )}
                                                        {
                                                            patientExerciseItem
                                                                ?.data
                                                                ?.accountDoctor
                                                                ?.pseudonym
                                                        }{' '}
                                                        {
                                                            patientExerciseItem
                                                                ?.data
                                                                ?.accountDoctor
                                                                ?.fullName
                                                        }
                                                    </p>
                                                    <p>
                                                        <i className="fas fa-redo text-warning" />{' '}
                                                        Số lượng cần tập mỗi lần
                                                        (số vòng/kg):{' '}
                                                        {
                                                            patientExerciseItem
                                                                ?.data
                                                                ?.quantityMinimum
                                                        }{' '}
                                                        –{' '}
                                                        {
                                                            patientExerciseItem
                                                                ?.data
                                                                ?.quantityMaximum
                                                        }
                                                    </p>
                                                    <p>
                                                        <i className="fas fa-redo text-warning" />{' '}
                                                        Số lần cần tập tập mỗi
                                                        séc:{' '}
                                                        {
                                                            patientExerciseItem
                                                                ?.data
                                                                ?.timesMinimum
                                                        }{' '}
                                                        –{' '}
                                                        {
                                                            patientExerciseItem
                                                                ?.data
                                                                ?.timesMaximum
                                                        }
                                                    </p>
                                                    <p>
                                                        <i className="fas fa-redo text-warning" />{' '}
                                                        Số séc cần tập mỗi buổi:{' '}
                                                        {
                                                            patientExerciseItem
                                                                ?.data
                                                                ?.numOfSecMinimum
                                                        }{' '}
                                                        –{' '}
                                                        {
                                                            patientExerciseItem
                                                                ?.data
                                                                ?.numOfSecMaximum
                                                        }
                                                    </p>
                                                    <p>
                                                        <i className="fas fa-redo text-warning" />{' '}
                                                        Tổng lượng mỗi buổi:{' '}
                                                        {patientExerciseItem
                                                            ?.data
                                                            ?.quantityMinimum *
                                                            patientExerciseItem
                                                                ?.data
                                                                ?.timesMinimum *
                                                            patientExerciseItem
                                                                ?.data
                                                                ?.numOfSecMinimum}{' '}
                                                        –{' '}
                                                        {patientExerciseItem
                                                            ?.data
                                                            ?.quantityMaximum *
                                                            patientExerciseItem
                                                                ?.data
                                                                ?.timesMaximum *
                                                            patientExerciseItem
                                                                ?.data
                                                                ?.numOfSecMaximum}
                                                    </p>
                                                </div>
                                            </div>
                                        ) : (
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <div className="mobile-desc">
                                                        <span
                                                            dangerouslySetInnerHTML={{
                                                                __html: patientExerciseItem
                                                                    ?.data
                                                                    ?.exercise
                                                                    ?.description
                                                            }}
                                                        />
                                                    </div>
                                                    <p>
                                                        <i className="fas fa-redo text-warning" />{' '}
                                                        Số lượng cần tập mỗi lần
                                                        (số vòng/kg):{' '}
                                                        {
                                                            patientExerciseItem
                                                                ?.data
                                                                ?.quantityMinimum
                                                        }{' '}
                                                        –{' '}
                                                        {
                                                            patientExerciseItem
                                                                ?.data
                                                                ?.quantityMaximum
                                                        }
                                                    </p>
                                                    <p>
                                                        <i className="fas fa-redo text-warning" />{' '}
                                                        Số lần cần tập tập mỗi
                                                        séc:{' '}
                                                        {
                                                            patientExerciseItem
                                                                ?.data
                                                                ?.timesMinimum
                                                        }{' '}
                                                        –{' '}
                                                        {
                                                            patientExerciseItem
                                                                ?.data
                                                                ?.timesMaximum
                                                        }
                                                    </p>
                                                    <p>
                                                        <i className="fas fa-redo text-warning" />{' '}
                                                        Số séc cần tập mỗi buổi:{' '}
                                                        {
                                                            patientExerciseItem
                                                                ?.data
                                                                ?.numOfSecMinimum
                                                        }{' '}
                                                        –{' '}
                                                        {
                                                            patientExerciseItem
                                                                ?.data
                                                                ?.numOfSecMaximum
                                                        }
                                                    </p>
                                                    <p>
                                                        <i className="fas fa-redo text-warning" />{' '}
                                                        Tổng lượng mỗi buổi:{' '}
                                                        {patientExerciseItem
                                                            ?.data
                                                            ?.quantityMinimum *
                                                            patientExerciseItem
                                                                ?.data
                                                                ?.timesMinimum *
                                                            patientExerciseItem
                                                                ?.data
                                                                ?.numOfSecMinimum}{' '}
                                                        –{' '}
                                                        {patientExerciseItem
                                                            ?.data
                                                            ?.quantityMaximum *
                                                            patientExerciseItem
                                                                ?.data
                                                                ?.timesMaximum *
                                                            patientExerciseItem
                                                                ?.data
                                                                ?.numOfSecMaximum}
                                                    </p>
                                                </div>
                                                <div className="col-md-6 align-self-start">
                                                    {videoLink ? (
                                                        <div className="player-wrapper">
                                                            <ReactPlayer
                                                                key={videoLink}
                                                                url={videoLink}
                                                                className="react-player"
                                                                width="100%"
                                                                height="100%"
                                                                controls
                                                                playing
                                                                muted
                                                                loop
                                                                playsinline
                                                            />
                                                        </div>
                                                    ) : (
                                                        <div
                                                            className="videoLink-placeholder bg-light d-flex align-items-center justify-content-center"
                                                            style={{
                                                                height: 200,
                                                                borderRadius: 5
                                                            }}
                                                        >
                                                            <p>
                                                                <i className="fas fa-videoLink fa-2x mb-2" />
                                                                <br />
                                                                'Xem videoLink
                                                                hướng dẫn ở đây'
                                                            </p>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        )}
                                        <div className="status-display mt-4 pt-3 border-top">
                                            <h5>
                                                Trạng thái:{' '}
                                                <span className="status status-in-progress">
                                                    {objectPracticeStatus.find(
                                                        (x) =>
                                                            x.value ==
                                                            patientExerciseItem
                                                                ?.data
                                                                ?.patientExerciseStatus
                                                    )
                                                        ? objectPracticeStatus.find(
                                                              (x) =>
                                                                  x.value ==
                                                                  patientExerciseItem
                                                                      ?.data
                                                                      ?.patientExerciseStatus
                                                          ).label
                                                        : ''}
                                                </span>
                                            </h5>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-12">
                                <div className="card card-primary card-outline">
                                    <div className="card-header">
                                        <h3 className="card-title">
                                            Lịch sử tập của bệnh nhân{' '}
                                            {
                                                patientExerciseItem?.data
                                                    ?.accountPatient?.fullName
                                            }
                                        </h3>
                                    </div>

                                    <h5
                                        className="mb-3"
                                        style={{
                                            marginLeft: '20px',
                                            marginTop: '20px'
                                        }}
                                    >
                                        Các buổi tập của bệnh nhân
                                    </h5>

                                    {patientExerciseItem?.data
                                        ?.patientExercisePractices?.length >
                                    0 ? (
                                        patientExerciseItem?.data?.patientExercisePractices
                                            .sort(
                                                (a, b) =>
                                                    new Date(
                                                        a.createdDate
                                                    ).getTime() -
                                                    new Date(
                                                        b.createdDate
                                                    ).getTime()
                                            )
                                            .map((itemChild, indexChild) => {
                                                const isVisible =
                                                    visibleVideos[itemChild.id];
                                                return (
                                                    <div
                                                        className="card-body"
                                                        style={{
                                                            paddingTop: '0px',
                                                            paddingBottom: '0px'
                                                        }}
                                                    >
                                                        <div id="practice-history">
                                                            <h5 className="mb-3">
                                                                <i className="fas fa-history" />{' '}
                                                                Buổi{' '}
                                                                {indexChild + 1}
                                                            </h5>
                                                            <div className="practice-record">
                                                                <div className="d-flex justify-content-between align-items-center">
                                                                    <span className="date">
                                                                        <i className="far fa-calendar-alt" />{' '}
                                                                        {formatDateTimeMoment(
                                                                            itemChild.createdDate
                                                                        )}
                                                                    </span>
                                                                    <span className="badge badge-success ml-2">
                                                                        <i className="fas fa-videoLink" />
                                                                        {itemChild.videoLink
                                                                            ? 'Video đã upload'
                                                                            : 'Không có Video'}
                                                                    </span>
                                                                </div>
                                                                <p className="mt-2 mb-1">
                                                                    <i className="fas fa-dumbbell" />{' '}
                                                                    Số lần tập:{' '}
                                                                    <strong>
                                                                        {
                                                                            itemChild.practiceCount
                                                                        }
                                                                    </strong>
                                                                </p>
                                                                <Button
                                                                    theme="primary"
                                                                    onClick={() =>
                                                                        toggleVideo(
                                                                            itemChild.id
                                                                        )
                                                                    }
                                                                >
                                                                    {isVisible
                                                                        ? 'Ẩn video'
                                                                        : 'Xem video bệnh nhân tập'}
                                                                </Button>
                                                                {isVisible && (
                                                                    <div
                                                                        className="player-wrapper"
                                                                        style={{
                                                                            marginTop: 12
                                                                        }}
                                                                    >
                                                                        <ReactPlayer
                                                                            key={
                                                                                itemChild.videoLink
                                                                            }
                                                                            url={
                                                                                BaseGatewayImage +
                                                                                itemChild.videoLink
                                                                            }
                                                                            className="react-player"
                                                                            width="30%"
                                                                            height="30%"
                                                                            controls
                                                                            playing
                                                                            loop
                                                                            muted
                                                                            playsinline
                                                                        />
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                );
                                            })
                                    ) : (
                                        <div className="card-body">
                                            <div id="practice-history">
                                                <div className="alert alert-info">
                                                    <i className="fas fa-info-circle" />{' '}
                                                    Chưa có buổi tập nào. Mời
                                                    thêm buổi tập!
                                                </div>
                                            </div>
                                        </div>
                                    )}

                                    {/* {patientExerciseItem?.data?.patientExercisePractices?.length > 0 ? (
                                        <Form.Group as={Row} className="mb-3">
                                            <Col
                                                md={{
                                                    span: 10,
                                                    offset: 5
                                                }}
                                            >
                                                <ButtonGroup className="mb-2">
                                                    {patientExerciseItem?.data?.patientExerciseStatus ==
                                                    practiceStatus.Pending ? (
                                                        <Button
                                                            style={{
                                                                marginLeft:
                                                                    'auto',
                                                                marginRight:
                                                                    'auto',
                                                                width: '20%',
                                                                marginBottom:
                                                                    '20px'
                                                            }}
                                                            onClick={() =>
                                                                handleUpdatePracticeStatus(
                                                                    practiceStatus.Pending,
                                                                    item.id
                                                                )
                                                            }
                                                            className="btn btn-primary"
                                                            activeClassName="active"
                                                        >
                                                            <i className="fas fa-check-circle" />{' '}
                                                            Bạn đã tập xong lần
                                                            này?
                                                        </Button>
                                                    ) : (
                                                        <></>
                                                    )}

                                                    {item.patientExerciseStatus ==
                                                    practiceStatus.Pending ? (
                                                        <Button
                                                            style={{
                                                                marginLeft:
                                                                    'auto',
                                                                marginRight:
                                                                    'auto',
                                                                width: '20%',
                                                                marginBottom:
                                                                    '20px'
                                                            }}
                                                            onClick={() =>
                                                                handleUpdatePracticeStatus(
                                                                    practiceStatus.InProgress,
                                                                    item.id
                                                                )
                                                            }
                                                            className="btn btn-danger"
                                                            activeClassName="active"
                                                        >
                                                            Thu hồi
                                                        </Button>
                                                    ) : (
                                                        <></>
                                                    )}
                                                </ButtonGroup>
                                            </Col>
                                        </Form.Group>
                                    ) : (
                                        <></>
                                    )} */}
                                </div>
                            </div>
                        </div>

                        {accountRoleAdmin &&
                        patientExerciseItem.data.patientExerciseStatus ==
                            practiceStatus.InProgress ? (
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="card card-primary card-outline">
                                        <div className="card-header">
                                            <h3 className="card-title">
                                                Sửa lại thông số
                                            </h3>
                                        </div>
                                        <Formik
                                            enableReinitialize
                                            validationSchema={yup
                                                .object()
                                                .shape({
                                                    quantityMinimum: yup
                                                        .number()
                                                        .integer(
                                                            'Phải là số nguyên'
                                                        )
                                                        .required(
                                                            'Số lượng tối thiểu không được để trống'
                                                        ),
                                                    quantityMaximum: yup
                                                        .number()
                                                        .integer(
                                                            'Phải là số nguyên'
                                                        )
                                                        .required(
                                                            'Số lượng tối đa không được để trống'
                                                        )
                                                        .min(
                                                            yup.ref(
                                                                'quantityMinimum'
                                                            ),
                                                            'Số lượng tối đa phải lớn hơn hoặc bằng số lượng tối thiểu'
                                                        ),
                                                    timesMinimum: yup
                                                        .number()
                                                        .integer(
                                                            'Phải là số nguyên'
                                                        )
                                                        .required(
                                                            'Số lần tối thiểu không được để trống'
                                                        ),
                                                    timesMaximum: yup
                                                        .number()
                                                        .integer(
                                                            'Phải là số nguyên'
                                                        )
                                                        .required(
                                                            'Số lần tối đa không được để trống'
                                                        )
                                                        .min(
                                                            yup.ref(
                                                                'timesMinimum'
                                                            ),
                                                            'Số lần tối đa phải lớn hơn hoặc bằng số lần tối thiểu'
                                                        ),
                                                    numOfSecMinimum: yup
                                                        .number()
                                                        .integer(
                                                            'Phải là số nguyên'
                                                        )
                                                        .required(
                                                            'Số sec tối thiểu không được để trống'
                                                        ),
                                                    numOfSecMaximum: yup
                                                        .number()
                                                        .integer(
                                                            'Phải là số nguyên'
                                                        )
                                                        .required(
                                                            'Số sec tối đa không được để trống'
                                                        )
                                                        .min(
                                                            yup.ref(
                                                                'numOfSecMinimum'
                                                            ),
                                                            'Số sec tối đa phải lớn hơn hoặc bằng số sec tối thiểu'
                                                        ),
                                                    numberOfDay: yup
                                                        .number()
                                                        .integer(
                                                            'Phải là số nguyên'
                                                        )
                                                        .required(
                                                            'Số ngày không được để trống'
                                                        ),
                                                    exercises: yup
                                                        .object()
                                                        .nullable()
                                                        .required(
                                                            messageError.emptyMessage
                                                        )
                                                })}
                                            onSubmit={(values) =>
                                                handleUpdateThongSo(values)
                                            }
                                            initialValues={{
                                                quantityMinimum:
                                                    patientExerciseItem.data &&
                                                    patientExerciseItem.data
                                                        .quantityMinimum
                                                        ? patientExerciseItem
                                                              .data
                                                              .quantityMinimum
                                                        : 0,
                                                quantityMaximum:
                                                    patientExerciseItem.data &&
                                                    patientExerciseItem.data
                                                        .quantityMaximum
                                                        ? patientExerciseItem
                                                              .data
                                                              .quantityMaximum
                                                        : 0,
                                                timesMinimum:
                                                    patientExerciseItem.data &&
                                                    patientExerciseItem.data
                                                        .timesMinimum
                                                        ? patientExerciseItem
                                                              .data.timesMinimum
                                                        : 0,
                                                timesMaximum:
                                                    patientExerciseItem.data &&
                                                    patientExerciseItem.data
                                                        .timesMaximum
                                                        ? patientExerciseItem
                                                              .data.timesMaximum
                                                        : 0,
                                                numOfSecMinimum:
                                                    patientExerciseItem.data &&
                                                    patientExerciseItem.data
                                                        .numOfSecMinimum
                                                        ? patientExerciseItem
                                                              .data
                                                              .numOfSecMinimum
                                                        : 0,
                                                numOfSecMaximum:
                                                    patientExerciseItem.data &&
                                                    patientExerciseItem.data
                                                        .numOfSecMaximum
                                                        ? patientExerciseItem
                                                              .data
                                                              .numOfSecMaximum
                                                        : 0,
                                                numberOfDay:
                                                    patientExerciseItem.data &&
                                                    patientExerciseItem.data
                                                        .numberOfDay
                                                        ? patientExerciseItem
                                                              .data.numberOfDay
                                                        : 0,
                                                feedbackDoctor:
                                                    patientExerciseItem.data &&
                                                    patientExerciseItem.data
                                                        .feedbackDoctor
                                                        ? patientExerciseItem
                                                              .data
                                                              .feedbackDoctor
                                                        : '',
                                                feedbackPatient:
                                                    patientExerciseItem.data &&
                                                    patientExerciseItem.data
                                                        .feedbackPatient
                                                        ? patientExerciseItem
                                                              .data
                                                              .feedbackPatient
                                                        : '',
                                                exercises:
                                                    patientExerciseItem.data &&
                                                    patientExerciseItem.data
                                                        .exercise
                                                        ? {
                                                              label: patientExerciseItem
                                                                  .data.exercise
                                                                  .name,
                                                              value: patientExerciseItem
                                                                  .data.exercise
                                                                  .id
                                                          }
                                                        : null
                                            }}
                                        >
                                            {({
                                                handleSubmit,
                                                handleChange,
                                                values,
                                                errors,
                                                setFieldValue
                                            }) => (
                                                <Form
                                                    style={{margin: '20px'}}
                                                    noValidate
                                                    onSubmit={handleSubmit}
                                                >
                                                    <Form.Group
                                                        as={Row}
                                                        className="mb-3"
                                                    >
                                                        <Form.Label className="col-sm-2 col-form-label">
                                                            Số lượng tối thiểu
                                                            tập mỗi lần
                                                            (vòng/kg)
                                                        </Form.Label>
                                                        <Col sm="10">
                                                            <Form.Control
                                                                placeholder="Số lượng tối thiểu tập mỗi lần (số vòng/kg)"
                                                                type="number"
                                                                name="quantityMinimum"
                                                                value={
                                                                    values.quantityMinimum
                                                                }
                                                                onChange={
                                                                    handleChange
                                                                }
                                                                isInvalid={
                                                                    !!errors.quantityMinimum
                                                                }
                                                            />
                                                            <Form.Control.Feedback type="invalid">
                                                                {
                                                                    errors.quantityMinimum
                                                                }
                                                            </Form.Control.Feedback>
                                                        </Col>
                                                    </Form.Group>
                                                    <Form.Group
                                                        as={Row}
                                                        className="mb-3"
                                                    >
                                                        <Form.Label className="col-sm-2 col-form-label">
                                                            Số lượng tối đa tập
                                                            mỗi lần (vòng/kg)
                                                        </Form.Label>
                                                        <Col sm="10">
                                                            <Form.Control
                                                                placeholder="Số lượng tối đa tập mỗi lần (số vòng/kg)"
                                                                type="number"
                                                                name="quantityMaximum"
                                                                value={
                                                                    values.quantityMaximum
                                                                }
                                                                onChange={
                                                                    handleChange
                                                                }
                                                                isInvalid={
                                                                    !!errors.quantityMaximum
                                                                }
                                                            />
                                                            <Form.Control.Feedback type="invalid">
                                                                {
                                                                    errors.quantityMaximum
                                                                }
                                                            </Form.Control.Feedback>
                                                        </Col>
                                                    </Form.Group>
                                                    <Form.Group
                                                        as={Row}
                                                        className="mb-3"
                                                    >
                                                        <Form.Label className="col-sm-2 col-form-label">
                                                            Số lần tập tối thiểu
                                                            mỗi séc
                                                        </Form.Label>
                                                        <Col sm="10">
                                                            <Form.Control
                                                                placeholder="Số lần tối đa tập mỗi séc"
                                                                type="number"
                                                                name="timesMinimum"
                                                                value={
                                                                    values.timesMinimum
                                                                }
                                                                onChange={
                                                                    handleChange
                                                                }
                                                                isInvalid={
                                                                    !!errors.timesMinimum
                                                                }
                                                            />
                                                            <Form.Control.Feedback type="invalid">
                                                                {
                                                                    errors.timesMinimum
                                                                }
                                                            </Form.Control.Feedback>
                                                        </Col>
                                                    </Form.Group>
                                                    <Form.Group
                                                        as={Row}
                                                        className="mb-3"
                                                    >
                                                        <Form.Label className="col-sm-2 col-form-label">
                                                            Số lần tập tối đa
                                                            mỗi séc
                                                        </Form.Label>
                                                        <Col sm="10">
                                                            <Form.Control
                                                                placeholder="Số lần tập tối đa mỗi séc"
                                                                type="number"
                                                                name="timesMaximum"
                                                                value={
                                                                    values.timesMaximum
                                                                }
                                                                onChange={
                                                                    handleChange
                                                                }
                                                                isInvalid={
                                                                    !!errors.timesMaximum
                                                                }
                                                            />
                                                            <Form.Control.Feedback type="invalid">
                                                                {
                                                                    errors.timesMaximum
                                                                }
                                                            </Form.Control.Feedback>
                                                        </Col>
                                                    </Form.Group>
                                                    <Form.Group
                                                        as={Row}
                                                        className="mb-3"
                                                    >
                                                        <Form.Label className="col-sm-2 col-form-label">
                                                            Số séc tối thiểu mỗi
                                                            buổi
                                                        </Form.Label>
                                                        <Col sm="10">
                                                            <Form.Control
                                                                placeholder="Số séc tối thiểu mỗi buổi"
                                                                type="number"
                                                                name="numOfSecMinimum"
                                                                value={
                                                                    values.numOfSecMinimum
                                                                }
                                                                onChange={
                                                                    handleChange
                                                                }
                                                                isInvalid={
                                                                    !!errors.numOfSecMinimum
                                                                }
                                                            />
                                                            <Form.Control.Feedback type="invalid">
                                                                {
                                                                    errors.numOfSecMinimum
                                                                }
                                                            </Form.Control.Feedback>
                                                        </Col>
                                                    </Form.Group>
                                                    <Form.Group
                                                        as={Row}
                                                        className="mb-3"
                                                    >
                                                        <Form.Label className="col-sm-2 col-form-label">
                                                            Số séc tối đa mỗi
                                                            buổi
                                                        </Form.Label>
                                                        <Col sm="10">
                                                            <Form.Control
                                                                placeholder="Số séc tối đa mỗi buổi"
                                                                type="number"
                                                                name="numOfSecMaximum"
                                                                value={
                                                                    values.numOfSecMaximum
                                                                }
                                                                onChange={
                                                                    handleChange
                                                                }
                                                                isInvalid={
                                                                    !!errors.numOfSecMaximum
                                                                }
                                                            />
                                                            <Form.Control.Feedback type="invalid">
                                                                {
                                                                    errors.numOfSecMaximum
                                                                }
                                                            </Form.Control.Feedback>
                                                        </Col>
                                                    </Form.Group>
                                                    <Form.Group
                                                        as={Row}
                                                        className="mb-3"
                                                    >
                                                        <Form.Label className="col-sm-2 col-form-label">
                                                            Số ngày tập
                                                        </Form.Label>
                                                        <Col sm="10">
                                                            <Form.Control
                                                                placeholder="Số ngày tập"
                                                                type="number"
                                                                name="numberOfDay"
                                                                value={
                                                                    values.numberOfDay
                                                                }
                                                                onChange={
                                                                    handleChange
                                                                }
                                                                isInvalid={
                                                                    !!errors.numberOfDay
                                                                }
                                                            />
                                                            <Form.Control.Feedback type="invalid">
                                                                {
                                                                    errors.numberOfDay
                                                                }
                                                            </Form.Control.Feedback>
                                                        </Col>
                                                    </Form.Group>
                                                    <Form.Group
                                                        as={Row}
                                                        className="mb-3"
                                                    >
                                                        <Form.Label className="col-sm-2 col-form-label">
                                                            Chọn bài tập
                                                        </Form.Label>
                                                        <Col sm="10">
                                                            <AsyncPaginate
                                                                name="exercises"
                                                                id="exercises"
                                                                placeholder="Chọn bài tập"
                                                                value={
                                                                    values.exercises
                                                                }
                                                                loadOptions={
                                                                    loadExerciseOptions
                                                                }
                                                                styles={
                                                                    styleSelectDefault
                                                                }
                                                                isClearable
                                                                onChange={(
                                                                    selectedOption
                                                                ) => {
                                                                    // const event = {
                                                                    //     target: {
                                                                    //         name: 'accountPatients',
                                                                    //         value: selectedOption
                                                                    //     }
                                                                    // };
                                                                    // setAccountHisId(event);
                                                                    setFieldValue(
                                                                        'exercises',
                                                                        selectedOption,
                                                                        true
                                                                    );
                                                                }}
                                                                additional={{
                                                                    page: 1,
                                                                    lstDiseaseId:
                                                                        patientExerciseItem.data &&
                                                                        patientExerciseItem
                                                                            .data
                                                                            .diseases
                                                                            ? patientExerciseItem.data.diseases.map(
                                                                                  (
                                                                                      disease
                                                                                  ) => ({
                                                                                      label: disease.name,
                                                                                      value: disease.id
                                                                                  })
                                                                              )
                                                                            : []
                                                                }}
                                                            />
                                                            <div
                                                                style={{
                                                                    display:
                                                                        'block',
                                                                    color: '#dc3545'
                                                                }}
                                                                className="invalid-feedback"
                                                            >
                                                                {
                                                                    errors.exercises
                                                                }
                                                            </div>
                                                        </Col>
                                                    </Form.Group>
                                                    <Form.Group
                                                        as={Row}
                                                        className="mb-3"
                                                    >
                                                        <Col
                                                            md={{
                                                                span: 10,
                                                                offset: 2
                                                            }}
                                                        >
                                                            <ButtonGroup className="mb-2">
                                                                <Button
                                                                    type="submit"
                                                                    theme="primary"
                                                                    // disabled={
                                                                    //     isLoading
                                                                    // }
                                                                >
                                                                    Sửa
                                                                </Button>
                                                                &nbsp;&nbsp;&nbsp;
                                                                <Button
                                                                    onClick={() =>
                                                                        history.goBack()
                                                                    }
                                                                    theme="secondary"
                                                                >
                                                                    Hủy
                                                                </Button>
                                                            </ButtonGroup>
                                                        </Col>
                                                    </Form.Group>
                                                </Form>
                                            )}
                                        </Formik>
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <></>
                        )}
                        {patientExerciseItem && patientExerciseItem.data ? (
                            <div className="row">
                                <div className="col-md-6">
                                    <div
                                        className="card card-info card-outline"
                                        id="doctor-feedback-section"
                                        // style={{display: 'none'}}
                                    >
                                        <div className="card-header">
                                            <h3 className="card-title">
                                                Bệnh nhân phản hồi
                                            </h3>
                                        </div>
                                        <div
                                            className="card-body"
                                            id="doctor-feedback-container"
                                        >
                                            {
                                                patientExerciseItem?.data
                                                    ?.feedbackPatient
                                            }
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div
                                        className="card card-success card-outline"
                                        id="patient-response-section"
                                        // style={{display: 'none'}}
                                    >
                                        <div className="card-header">
                                            <h3 className="card-title">
                                                Bác sĩ phản hồi
                                            </h3>
                                        </div>
                                        <div className="card-body">
                                            <div id="patient-response-container">
                                                {/* Will be populated by JavaScript */}
                                            </div>
                                            <div id="response-form-container">
                                                <Formik
                                                    enableReinitialize
                                                    validationSchema={schema}
                                                    onSubmit={(values) =>
                                                        handleUpdate(values)
                                                    }
                                                    initialValues={{
                                                        feedbackDoctor:
                                                            patientExerciseItem.data &&
                                                            patientExerciseItem
                                                                .data
                                                                .feedbackDoctor
                                                                ? patientExerciseItem
                                                                      .data
                                                                      .feedbackDoctor
                                                                : '',
                                                        agreeWithPatient: patientExerciseItem.data &&
                                                            patientExerciseItem
                                                                .data
                                                                .patientExerciseStatus == practiceStatus.Rejected
                                                                ? false
                                                                : true,
                                                        // bởi vì trong dữ liệu đã lưu là Kem khi tạo nên trên giao diện default là Kém
                                                        doctorEvaluationStatus:
                                                            patientExerciseItem.data &&
                                                            patientExerciseItem
                                                                .data
                                                                .doctorEvaluationStatus
                                                                ? objectDoctorEvaluationStatus.find(
                                                                      (x) =>
                                                                          x.value ==
                                                                          patientExerciseItem
                                                                              .data
                                                                              .doctorEvaluationStatus
                                                                  )
                                                                : objectDoctorEvaluationStatus[0]
                                                    }}
                                                >
                                                    {({
                                                        handleSubmit,
                                                        handleChange,
                                                        values,
                                                        errors,
                                                        setFieldValue
                                                    }) => (
                                                        <Form
                                                            noValidate
                                                            onSubmit={
                                                                handleSubmit
                                                            }
                                                        >
                                                            <Form.Group
                                                                as={Row}
                                                                className="mb-3"
                                                            >
                                                                <Form.Control
                                                                    placeholder="Bác sĩ phản hồi"
                                                                    as="textarea"
                                                                    rows={4}
                                                                    name="feedbackDoctor"
                                                                    value={
                                                                        values.feedbackDoctor
                                                                    }
                                                                    onChange={
                                                                        handleChange
                                                                    }
                                                                    // isInvalid={!!errors.practiceCountMinimum}
                                                                />
                                                                <div
                                                                    style={{
                                                                        display:
                                                                            'block',
                                                                        color: '#dc3545'
                                                                    }}
                                                                    className="invalid-feedback"
                                                                >
                                                                    {
                                                                        errors.feedbackDoctor
                                                                    }
                                                                </div>
                                                            </Form.Group>
                                                            <Form.Group
                                                                as={Row}
                                                                className="mb-3"
                                                            >
                                                                <Form.Label className="col-sm-2 col-form-label">
                                                                    Bệnh nhân
                                                                    tập đúng?
                                                                </Form.Label>

                                                                <Col
                                                                    sm="10"
                                                                    className="icheck-primary"
                                                                >
                                                                    <Form.Control
                                                                        id="checkboxPrimary1"
                                                                        type="checkbox"
                                                                        placeholder="Bệnh nhân tập đúng?"
                                                                        name="agreeWithPatient"
                                                                        checked={
                                                                            values.agreeWithPatient
                                                                        }
                                                                        onClick={
                                                                            handleChange
                                                                        }
                                                                    />
                                                                    <Form.Label htmlFor="checkboxPrimary1">
                                                                        {' '}
                                                                    </Form.Label>
                                                                </Col>
                                                            </Form.Group>
                                                            <Form.Group
                                                                as={Row}
                                                                className="mb-"
                                                            >
                                                                <Form.Label className="col-sm-2 col-form-label">
                                                                    Đánh giá
                                                                    bệnh nhân
                                                                    tập
                                                                </Form.Label>
                                                                <Col sm="10">
                                                                    <Select
                                                                        name="doctorEvaluationStatus"
                                                                        id="doctorEvaluationStatus"
                                                                        placeholder="Đánh giá bệnh nhân tập"
                                                                        value={
                                                                            values
                                                                                .doctorEvaluationStatus
                                                                        }
                                                                        onChange={(
                                                                            selectedOption
                                                                        ) => {
                                                                            setFieldValue(
                                                                                'doctorEvaluationStatus',
                                                                                selectedOption,
                                                                                true
                                                                            );
                                                                        }}
                                                                        options={
                                                                            objectDoctorEvaluationStatus
                                                                        }
                                                                        styles={
                                                                            errors.doctorEvaluationStatus !==
                                                                            undefined
                                                                                ? styleSelectError
                                                                                : styleSelectDefault
                                                                        }
                                                                    />
                                                                    <div
                                                                        style={{
                                                                            display:
                                                                                'block',
                                                                            color: '#dc3545'
                                                                        }}
                                                                        className="invalid-feedback"
                                                                    >
                                                                        {
                                                                            errors.doctorEvaluationStatus
                                                                        }
                                                                    </div>
                                                                </Col>
                                                            </Form.Group>
                                                            <Form.Group
                                                                as={Row}
                                                                className="mb-3"
                                                            >
                                                                <Col
                                                                    md={{
                                                                        span: 10,
                                                                        offset: 2
                                                                    }}
                                                                >
                                                                    <ButtonGroup className="mb-2">
                                                                        {patientExerciseItem
                                                                            .data
                                                                            .patientExerciseStatus &&
                                                                        patientExerciseItem
                                                                            .data
                                                                            .patientExerciseStatus ===
                                                                            practiceStatus.Pending ? (
                                                                            <Button
                                                                                type="submit"
                                                                                theme="primary"
                                                                                // disabled={
                                                                                //     isLoading
                                                                                // }
                                                                            >
                                                                                Phản
                                                                                hồi
                                                                            </Button>
                                                                        ) : (
                                                                            <>

                                                                            </>
                                                                        )}
                                                                        &nbsp;&nbsp;&nbsp;
                                                                        <Button
                                                                            onClick={() =>
                                                                                history.goBack()
                                                                            }
                                                                            theme="secondary"
                                                                        >
                                                                            Hủy
                                                                        </Button>
                                                                    </ButtonGroup>
                                                                </Col>
                                                            </Form.Group>
                                                        </Form>
                                                    )}
                                                </Formik>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <></>
                        )}
                    </div>
                </>
            )}
        </div>
    );
};

export default DoctorObserveDetail;
